<template>
  <div class="flex flex-col gap-5">
    <div class="text-md font-bold">
      <p>Offers</p>
    </div>
    <div
      class="flex items-center border-2 border-gray-300 rounded px-2 py-1 w-full bg-white"
    >
      <UInput
        type="text"
        size="xl"
        v-model="selected"
        placeholder="Enter coupon code"
        class="w-full"
        :ui="{
          base: 'flex-1 bg-transparent focus:outline-none focus:ring-0 border-none shadow-none px-4',
          variant: {
            none: 'border-none',
          },
        }"
        variant="none"
        :readonly="isReadOnly"
        @click="onInputClick"
        @focus="onFocus"
      />
      <UButton
        size="xl"
        label="APPLY"
        class="ml-2 px-4 py-2 rounded-full bg-gradient-to-r from-orange-400 to-orange-500 text-white font-bold"
        @click="applyCouponText"
        :disabled="selected.length === 0"
      />
    </div>
    <!-- <div>
      <p class="text-base font-bold">Available offers</p>
    </div> -->
    <div v-if="isLoading">
      <p>Fetching offers...</p>
    </div>
    <div v-else-if="!isLoading && coupons.length === 0">
      <p>No offers available now</p>
    </div>
    <div v-else>
      <div class="max-h-[400px] overflow-y-auto">
        <div class="flex flex-col gap-4">
          <div class="" v-for="(item, index) in coupons" :key="index">
            <V3CouponCardComponent
              :data="item"
              @apply="applyFromList"
              @refresh="refeshData"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventParameter } from '~/google_analytics/events.enum';

const runtimeConfig = useRuntimeConfig();
const cart = useCart();
const isLoading = ref(false);
const props = defineProps(["data"]);
const coupons = ref([]);
const emits = defineEmits(["apply"]);
const auth = useAuth();
const { gtag } = useGtag();
const data = computed(() => cart.response?.data);
const error = computed(() => cart.response?.error);
const authToken = computed(() => auth.access_token);
const summary = computed(() =>
  error.value ? [] : data.value?.map((k:any) => k.summary).flat() || []
);
const isAuthenticated = auth && auth.access_token;
const userData = isAuthenticated
  ? {
      user_name: auth.user.first_name,
      user_phone: auth.user.phone,
      user_email: auth.user.email,
    }
  : {
      user_name: null,
      user_phone: null,
      user_email: null,
    };
const selected = ref("");
const isReadOnly = ref(false);

onMounted(async () => {
  if (coupons.value.length === 0) {
    await fetchCoupons();
  } else {
    addData();
  }
});

const refeshData = async (couponCode: string) => {
  console.log(couponCode);

  const updatedData = props.data.map((item: any) => {
    return {
      ...item,
      readMore: item.coupon_code === couponCode,
      tncToShow: item.coupon_code === couponCode ? 100 : 3,
    };
  });

  coupons.value = updatedData;
};

const addData = () => {
  for (let i = 0; i < props.data.length; i++) {
    Object.assign(props.data[i], { readMore: false, tncToShow: 3 });
  }

  coupons.value = props.data;
};

const fetchCoupons = async () => {
  isLoading.value = true;
  if (cart && cart.items && cart.items.length > 0) {
    const providerIds = [...new Set(cart.items.map((item) => item.provider?.ukid))];
    const sellerIds = [...new Set(cart.items.map((item) => item.seller?.id))];
    const skuIds = [...new Set(cart.items.map((item) => item.sku_id))];
    const category = [
      ...new Set(cart.items.map((item) => item.category?.parent?.code)),
    ];
    const transactionID = cart.transaction_id;
    const deliveryCharge = summary.value.filter((k:any) => k.type.toLowerCase() === "delivery" && Number(k.total) !== 0)
    try {
      const { data } = await useAPIHandler("post", "/offers/list", {
        body: {
          partner_id: runtimeConfig.public.partnerCode,
          seller_id: sellerIds,
          provider_ukid: providerIds,
          categories: category,
          mobile: authToken.value ? auth.user : null,
          delivery_charges: deliveryCharge && deliveryCharge.length>0 ? true : false,
          transaction_id: transactionID,
          sku_ids: skuIds,
          // minimum_order_value: cart.itemTotal.toString()
        },
      });
      data.sort((a: any, b: any) => {
        if (a.applicable !== b.applicable) {
          return a.applicable ? -1 : 1;
        }
        const seqA = a.sequence_number
          ? Number(a.sequence_number)
          : Number.MAX_SAFE_INTEGER;
        const seqB = b.sequence_number
          ? Number(b.sequence_number)
          : Number.MAX_SAFE_INTEGER;
        return seqA - seqB;
      });
      for (let i = 0; i < data.length; i++) {
        Object.assign(data[i], { readMore: false, tncToShow: 3 });
      }
      coupons.value = data;
    } catch (err: any) {
      console.log(err.message);
    } finally {
      isLoading.value = false;
    }
  } else {
    isLoading.value = false;
  }
};

const onInputClick = () => {
  isReadOnly.value = false;
  // Focus the input field
  nextTick(() => {
    const inputField = document.querySelector(
      'input[placeholder="Enter coupon code"]'
    ) as HTMLInputElement;
    inputField?.focus();
  });
};
const applyCouponText = () => {
  emits("apply", selected.value);
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: "Apply coupon Apply",
    [EventParameter.COUPON_CODE]: selected.value?.toUpperCase(),
  });
};
const applyFromList = (couponCode: string) => {
  emits("apply", couponCode);
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: "Available offers Apply",
    [EventParameter.COUPON_CODE]: couponCode?.toUpperCase(),
  });
};

const onFocus = (event: FocusEvent) => {
  const target = event.target as HTMLElement;
  setTimeout(() => {
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, 300);
};
</script>
